export default {
  labelsLoaded (state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  loading (state) {
    state.loading += 1
  },
  free (state) {
    state.loading -= 1
  },
  setSpaCard (state, { title, cards }) {
    state.spa = cards
    state.title = title
  },
  setQueryParamError (state, status) {
    state.queryParamError = status
  }
}
